<template>
	<div class="container">

		<el-scrollbar id="menuWarpper" style="height:calc(99%);background-color: #FFFFFF;margin-top: 0px;">
			<div class="main">
				<!-- <el-button class="fanhuiBtn" @click="fanhui()">返回</el-button> -->
				<div class="yonghuminglabe">权限新增</div>
				<div class="header-con">
					<div class="maina">
						<el-form :model="form" :rules="formRule" ref="form" label-width="140px" label-position="right"
							style="display: inline">
							<el-row>

								<el-form-item style="width:90%" label="权限名称：" prop="quanxianmingcheng">
									<el-input style="width:90%" type="text" v-model="form.quanxianmingcheng"
										ref="quanxianmingcheng" @keyup.enter.native="xzlujingdizhi" placeholder="请输入名称">
									</el-input>

								</el-form-item>
								<el-form-item style="width:90%" label="父级：" prop="fuji">
									<el-select style="width:90%" v-model="form.fuji" filterable clearable
										placeholder="输入关键词搜索" :filter-method="bindSelectChange" @change="dianjifuji"
										popper-class="eloption">
										<el-option v-for="item in staff" :key="item.TITLE" :label="item.TITLE"
											:value="item.TITLE">
										</el-option>
									</el-select>
								</el-form-item>


								<el-form-item style="width:90%" label="路径地址：" prop="lujingdizhi"
									v-if="form.fuji!='一级权限'">
									<el-input style="width:90%" type="text" v-model="form.lujingdizhi" ref="lujingdizhi"
										placeholder="请输入路径地址">
									</el-input>
								</el-form-item>



								<el-form-item style="width:90%" label="排序：">
									<el-input-number v-model="paixu" @change="handleChange" v-if="paixu==undefined"
										@input="orderNoChange" :min="1" ref="paixu">

									</el-input-number>
									<el-input-number v-model="paixu" @change="handleChange" :min="1" ref="paixu">

									</el-input-number>
								</el-form-item>



								<el-col :span="24">

									<el-button class="tijiaobtn" type="primary" @click="submitForm()" :disabled="isTiJiao">提交
									</el-button>
								</el-col>
							</el-row>

						</el-form>

					</div>


				</div>
			</div>

		</el-scrollbar>

	</div>
</template>

<script>
	import PinyinMatch from "pinyin-match";
	export default {
		name: "quanxianxinzeng",
		data() {
			return {
				isTiJiao:false,
				paixu: 1,
				paixua: 1,
				EchartsHeight: (document.body.clientHeight - 200) + 'px',
				formDialog: false,
				yonghuming: JSON.parse(localStorage.getItem("userInfo")).NAME,
				/**表单 */
				form: {
					quanxianmingcheng: "", //客户账号
					lujingdizhi: "", //客户密码
					fuji: "", //父级

				},
				tableData: [],
				currPage: 1,
				pageSize: 50,
				allPage: 0,
				staffcopy: [],
				staff: [], //产品线
				staffz: [], //产品线
				jueseListcopy: [],
				jueseList: [],
				jueseListz: [],
				loading: false, //搜索加载状态
				scoped: false,

				/*表单规则 */
				formRule: {
					paixu: [{
						required: true,
						message: "请选择",
					}],
					fuji: [{
						required: true,
						message: "请选择",
						// trigger: "blur"
					}],
					lujingdizhi: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
					quanxianmingcheng: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],

					juese: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],

				},
			};
		},

		mounted() {

			
			const that = this;
			window.onresize = () => {
				// return (() => {
					window.screenHeight = document.body.clientHeight
					that.EchartsHeight = (window.screenHeight - 200) + 'px'
				// })()
			}
		
			this.getPerson()
			this.getJueSe()
		},
		activated() {
			
			
			const that = this;
			window.onresize = () => {
				// return (() => {
					window.screenHeight = document.body.clientHeight
					that.EchartsHeight = (window.screenHeight - 200) + 'px'
				// })()
			}
					
			this.getPerson()
			this.getJueSe()
			
		},

		methods: {
			orderNoChange() {
				this.paixu = 1;
				this.$forceUpdate();

			},
			handleChange(value) {

				this.paixu = value;

			},
			dianjifuji() {
				this.staff = this.staffz;
			
			},
			bindSelectChange(val) {
				if (val) {
					this.staff = this.staffcopy.filter((item) => {
						return PinyinMatch.match(item.TITLE, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.staff = this.staffcopy
				}

			},
			/**获取父级 */
			getPerson() {
				this.loading = true;

				this.$request({
						method: "GET",
						url: "Power/GetTopLevelPowerList",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {



							this.staff = res.Data;
							this.staffz = res.Data;
							this.staffcopy = this.staff;


							if (this.staff.length > 0) {
								this.form.person = this.staff[0].Code;
							}

						}

					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			/**获取角色 */
			getJueSe() {
				this.loading = true;

				this.$request({
						method: "GET",
						url: "Dictionary/GetRoles",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {



							this.jueseList = res.Data;
							this.jueseListz = res.Data;
							this.jueseListcopy = this.jueseList;

							if (this.jueseList.length > 0) {
								this.form.juese = this.jueseList[0].Code;
							}

						}

					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			/**提交选项 */
			submitForm() {


				this.$refs.form.validate((valid) => {
					if (valid) {

						if (this.form.quanxianmingcheng.length == 0 || this.form.quanxianmingcheng.length > 0 &&
							this.form
							.quanxianmingcheng.trim().length == 0) {
							this.$message({
								message: "权限名称不能为空！",
								type: "error",
							});
						} else if (this.form.fuji.length == 0) {
							this.$message({
								message: "父级不能为空！",
								type: "error",
							});
						} else {
							var shangjixuhao = '';
							for (var a in this.staff) {
								if (this.staff[a].TITLE == this.form.fuji) {
									shangjixuhao = this.staff[a].ID
								}
							}
							if (shangjixuhao == null) {
								shangjixuhao = ""
							}
							let data = {

								ID: "", //序号
								TITLE: this.form.quanxianmingcheng, //标题
								TOUTE: this.form.lujingdizhi, //路径
								SUPERIOR_ID: shangjixuhao, //排序
								SORT: this.paixu, //角色
								STATUS: "1", //状态


							};
							if (this.form.fuji == "一级权限") {
								data = {

									ID: "", //序号
									TITLE: this.form.quanxianmingcheng, //标题
									TOUTE: "#", //路径
									SORT: this.paixu,
									STATUS: "1", //状态


								};
							}
							this.isTiJiao=true;
							// this.formDialog = true;

							this.scoped = true;

							this.$request({
									method: "post",
									url: "Power/Edit",
									data: data,
								})
								.then(() => {
									this.isTiJiao=false;
									this.$message({
										message: "发起成功！",
										type: "success",
									});
									this.form.quanxianmingcheng = "";
									this.paixu = 1;
									this.form.lujingdizhi = "";
									this.form.fuji = "";
									this.getPerson()

								})
								.catch((err) => {
									this.isTiJiao=false;
									if (err == "Error: Request failed with status code 401") {
										this.$router.push({
											path: "/login",
										});
									}
								});
						}

					}
					// }
				});
			},
			/**重置表单 */
			resetForm() {
				this.$refs.form.resetFields();
			},
			//回车事件
			xzlujingdizhi() {
				this.$nextTick(() => {
					this.$refs.lujingdizhi.focus()
				})
			},


			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val;
				this.currPage = 1;
				this.ChaXun();
			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.currPage = val;
				this.ChaXun();
			},
			/**刷新表格数据 */
			handleRefresh() {
				this.currPage = 1;
				this.ChaXun();
			},


		},
	};
</script>

<style scoped>
	.container {
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		background-color: #F0F0F0;
	}

	.containera {
		width: 100%;
		height: 100%;
		padding-left: 10px;
		margin-top: -10px;
		box-sizing: border-box;
		background-color: #FFFFFF;
	}

	.header {
		margin-top: 10px;
		margin-bottom: 15px;
		padding-left: 20px;
	}

	.headera {
		margin-bottom: 2px;
	}



	.fanhuiBtn {
		margin-top: 0px;
		margin-left: 0px;
		margin-bottom: 20px;
		display: inline-block;
	}

	.el-input {
		width: 100px;
	}

	.yonghuminglabe {
		margin-top: 30px;
		margin-left: 30px;
		margin-bottom: 0px;
		display: inline-block;
	}

	/* 主体容器 */
	.main {
		height: 100%;
		overflow: hidden;
		background-color: #fff;
		padding: 0px;
		box-sizing: border-box;
	}

	.tijiaobtn {
		margin-left: 50%;
		margin-top: 10px;
		width: 100px;
		margin-bottom: 20px;
	}

	.header-con {
		margin-left: 50px;
		margin-right: 50px;
		margin-top: 30px;
	}

	.header-cona {
		display: flex;
		align-items: center;
		height: 30px;
		margin-left: 30px;
	}


	.header-con-form {
		display: flex;
		align-items: center;
	}

	.header-con-form-item {
		margin-bottom: 0;
	}

	/**输入框宽度 */
	.form-item-input {
		width: 400px;
	}

	/**输入框后面的备注 */
	.form-item-tip {
		display: inline-block;
		margin-left: 10px;
		color: #606266;
		font-size: 14px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	/* 主体容器 */
	.maina {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 10px;
		box-sizing: border-box;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	}

	.el-card {
		box-shadow: 0 1px 1px #F5F5F5 !important;
	}

	/deep/.eloption .el-select-dropdown__wrap {
		max-height: 400px !important;
	}
	.el-table {
		overflow-y: auto !important;
		overflow-x: auto !important;
	}
</style>
